module.exports = __webpack_public_path__ + "static/media/15UN-Habitat3.3b9de749.jpg";